export default __webpack_public_path__ + "static/media/product-tracker-sm.05edbb8e.jpg";